import {
	ChangeDetectorRef,
	Component,
	Inject,
	Input,
	OnInit,
} from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

import { AddBrandModel } from '../../models/brands.model'
import { UploadImageComponent } from 'src/app/shared/components/upload-image/upload-image.component'
import { ImageUpload } from 'src/app/shared/models/general.models'
import { Subscription } from 'rxjs'
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from '@angular/material/dialog'
import { environment } from 'src/environments/environment'
import { StoreService } from '../../services/store.service'
import { ImageUploadNoCropperComponent } from 'src/app/shared/components/image-upload-no-cropper/image-upload-no-cropper.component'

@Component({
	selector: 'app-add-edit-brand',
	templateUrl: './add-edit-brand.component.html',
	styleUrls: ['./add-edit-brand.component.scss'],
})
export class AddEditBrandComponent implements OnInit {
	formData: FormGroup = new FormGroup({})
	imgConfig: ImageUpload = {
		imageCropDimensions: 2.1,
		imageWidth: 800,
		imageHeight: 500,
	}
	subscription = new Subscription()
	formEditedData: any
	imagePath = environment.attachmentPath
	enNameExist = false
	arNameExist = false
	constructor(
		public dialog: MatDialogRef<AddEditBrandComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogO: MatDialog,
		private storeService: StoreService,
		private cd: ChangeDetectorRef
	) {
		this.formEditedData = data.formEditedData
	}

	ngOnInit(): void {
		this.formData = new FormGroup({
			formControl: new FormControl(this.formEditedData?.enName || '', [
				Validators.required,
			]),
			formControl2: new FormControl(this.formEditedData?.arName || '', [
				Validators.required,
			]),

			image: new FormControl(this.formEditedData?.imageUrl || null),
		})
		this.isImgRequired()
		console.log(this.data.type == 'add')
		console.log(this.data?.editBrand)
		console.log(this.formEditedData?.parentId)
		console.log(this.getController('image')?.value)
	}
	isImgRequired() {
		if (
			this.formEditedData?.parentId == null &&
			(this.data.typeTitle == 'cat' || this.data.typeTitle == 'brand') &&
			this.data.hasImg
		) {
			this.getController('image').addValidators(Validators.required)
			this.getController('image').updateValueAndValidity()
		} else {
			this.getController('image').removeValidators(Validators.required)
			this.getController('image').updateValueAndValidity()
		}
	}
	closeDialog() {
		this.dialog.close()
	}
	uploadImage() {
		this.dialogO
			.open(ImageUploadNoCropperComponent, {
				width: '752px',
				panelClass: 'overflow-y-auto',
				data: this.imgConfig,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						const body = new FormData()
						body.append('image', res.selectedFile)

						if (this.data.typeTitle == 'brand') {
							this.storeService.uploadBrandImage(body).subscribe((res: any) => {
								// this.isChanged = true
								this.getController('image')?.setValue(res?.result?.url)
							})
						} else {
							this.storeService
								.UploadCategoryImage(body)
								.subscribe((res: any) => {
									// this.isChanged = true
									this.getController('image')?.setValue(res?.result?.url)
								})
						}
					}
				},
			})
	}
	checkNameExist(name: string) {
		let val = this.getController(name)?.value
		if (this.data.typeTitle == 'brand' && val?.length > 1) {
			if (name == 'formControl') {
				this.subscription.add(
					this.storeService
						.brandIsNameEnExistsBefore(val)
						.subscribe((res: any) => {
							this.enNameExist = res.result
						})
				)
			} else if (name == 'formControl2') {
				this.subscription.add(
					this.storeService
						.brandIsNameArExistsBefore(val)
						.subscribe((res: any) => {
							this.arNameExist = res.result
						})
				)
			}
		} else if (this.data.typeTitle != 'brand' && val?.length > 1) {
			if (name == 'formControl') {
				this.subscription.add(
					this.storeService
						.categoryNameEnExistsBefore(val)
						.subscribe((res: any) => {
							this.enNameExist = res.result
						})
				)
			} else if (name == 'formControl2') {
				this.subscription.add(
					this.storeService
						.categoryIsNameArExistsBefore(val)
						.subscribe((res: any) => {
							this.arNameExist = res.result
						})
				)
			}
		}
	}
	confirm() {
		let formData = {
			f1: this.getController('formControl').value,
			f2: this.getController('formControl2').value,
			f3: this.getController('image').value,
		}
		this.dialog.close(formData)
	}

	getController(controlName: any) {
		return this.formData.controls[controlName]
	}
}
